module.exports = {"150929100":"乌兰花镇","150929101":"吉生太镇","150929102":"库伦图镇","150929103":"供济堂镇","150929104":"白音朝克图镇","150929200":"红格尔苏木","150929201":"江岸苏木","150929202":"查干补力格苏木","150929203":"脑木更苏木","150929204":"东八号乡","150929205":"忽鸡图乡","150929206":"大黑河乡","150929207":"巴音敖包苏木","150929400":"乌兰牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150929.json
// module id = 563
// module chunks = 0